import { observable } from 'mobx';
import { Product } from './Product';
import { IFilterQuery } from '../../views/product-filters/IProductFilters';
import { toCamelCase } from './../../utils/ToCamelCase';
import { Sku } from './Sku';

export interface IFilterMapItem {
    keyType: string;
    keyName: string;
}

export enum filterQueryLevel {
    SKU = 'sku',
    PRODUCT = 'product'
}

export enum filterQueryKeyTypes {
    MACHINE_NAME = 'machine_name',
    ARRAY_OF_OBJECTS = 'array_of_objects',
    OBJECT = 'object'
}

export class FilterQuery {
    @observable private map: IFilterMapItem[];
    @observable public level: filterQueryLevel;

    constructor(filterQueryJson: IFilterQuery) {
        this.level = filterQueryJson.level;

        if (!filterQueryJson.map.map) {
            this.map = [];

            return;
        }

        this.map = filterQueryJson.map.map((mapItem) => {
            return {
                keyType: mapItem.key_type,
                keyName: toCamelCase(mapItem.key_name)
            };
        });
    }

    public extract(product: Product) {
        return this.extractFromProduct(product, this.map, this.level);
    }

    private extractFromProduct(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        productData: any,
        filterMap: IFilterMapItem[],
        level: string = filterQueryLevel.PRODUCT
    ): string[] {
        if (level === filterQueryLevel.SKU) {
            const filterQueryValues: string[] = productData.skus.reduce(
                (extractedValues: string[], sku: Sku) => {
                    const currentSkuValues: string[] = this.extractFromProduct(sku, filterMap);

                    return extractedValues.concat(currentSkuValues);
                },
                []
            );

            return [...new Set(filterQueryValues)];
        }

        const _filterMap = [...filterMap];
        const currentItem = _filterMap.length ? _filterMap.shift() : null;

        if (currentItem && productData) {
            const _productData = productData[currentItem.keyName];

            if (currentItem.keyType === filterQueryKeyTypes.MACHINE_NAME) {
                return _productData;
            } else if (currentItem.keyType === filterQueryKeyTypes.ARRAY_OF_OBJECTS) {
                if (!_productData || !_productData.length) {
                    return [''];
                }

                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return _productData.reduce((allItemsValues: string[], item: any) => {
                    return allItemsValues.concat(this.extractFromProduct(item, _filterMap));
                }, []);
            }

            return this.extractFromProduct(_productData, _filterMap);
        }

        return [''];
    }
}
